@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }

  100% {
    transform: scale(1);
  }
}

:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.comparison-bar__container {
  background: #ffd100;
  height: 0;
  overflow: hidden;
  transition: height 0.25s cubic-bezier(0, 0, 0.6, 1);
  font-size: 0.875rem;
  color: #333333;
}

@media screen and (min-width: 720px) {
  .comparison-bar__container {
    margin-bottom: -12px;
    margin-top: 12px;
  }
}

.comparison-bar__container--hidden {
  height: 0;
}

@media screen and (max-width: 979px) {
  .comparison-bar__container--visible {
    height: 48px;
  }
}

@media screen and (min-width: 980px) {
  .comparison-bar__container--visible {
    height: 56px;
  }
}

.comparison-bar__container--is-animating {
  animation: pulse 0.25s;
  animation-iteration-count: 1;
}

.comparison__bar {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media screen and (max-width: 979px) {
  .comparison__bar {
    height: 48px;
  }
}

@media screen and (min-width: 980px) {
  .comparison__bar {
    height: 56px;
    justify-content: space-between;
  }

  :host(:not([dir="rtl"])) .comparison__bar {
    padding-left: 130px;
    padding-right: 72px;
  }

  :host([dir="rtl"]) .comparison__bar {
    padding-right: 130px;
    padding-left: 72px;
  }
}

.comparison__info {
  display: flex;
  align-items: center;
}

.compare__info {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}

:host(:not([dir="rtl"])) .compare__info {
  margin-right: 32px;
}

:host([dir="rtl"]) .compare__info {
  margin-left: 32px;
}

:host(:not([dir="rtl"])) .compare__info-label {
  margin-right: 4px;
}

:host([dir="rtl"]) .compare__info-label {
  margin-left: 4px;
}

.compare_qty {
  display: inline-flex;
}

.compare__clear-btn {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  color: #333333;
  display: inline-flex;
  align-items: center;
  transition: color 0.25s;
}

:host(:not([dir="rtl"])) .compare__clear-btn {
  margin-right: 32px;
}

:host([dir="rtl"]) .compare__clear-btn {
  margin-left: 32px;
}

.compare__clear-btn:hover {
  color: #0f0f0f;
}

.compare__clear-btn:hover .compare__clear-label {
  text-decoration: underline;
}

:host(:not([dir="rtl"])) .compare__clear-icon {
  margin-right: 10px;
}

:host([dir="rtl"]) .compare__clear-icon {
  margin-left: 10px;
}

.comparison__link--mobile {
  flex: 1 1 auto;
  color: #333333;
  text-decoration: none;
  padding: 16px 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comparison__link--mobile:hover {
  background: #e6bc00;
}

.compare__clear-label--mobile {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  color: #333333;
  padding: 12px 14px;
  transition: all 0.25s;
}

:host(:not([dir="rtl"])) .compare__clear-label--mobile {
  border-left: 1px solid rgba(51, 51, 51, 0.3);
}

:host([dir="rtl"]) .compare__clear-label--mobile {
  border-right: 1px solid rgba(51, 51, 51, 0.3);
}

.compare__clear-label--mobile:hover {
  color: #0f0f0f;
  background: #e6bc00;
}